/**
 * The PWA service worker registration and the "apply the waiting update"
 * action, parked in a LEAF module (imports nothing) so barrel-reachable code
 * like `api.ts` can use them without importing `virtual:pwa-register` - that
 * virtual module only exists in builds that load vite-plugin-pwa (admin and
 * partner). In sales and brandOwner both values simply stay null.
 *
 * Written by `registerAppSw.tsx` at app boot; read by the 426 upgrade path in
 * `api/api.ts`.
 */
let registration: ServiceWorkerRegistration | null = null;
let applyPendingUpdate: (() => Promise<void>) | null = null;

export const setSwRegistration = (r: ServiceWorkerRegistration) => {
  registration = r;
};

export const getSwRegistration = () => registration;

export const setApplyPendingUpdate = (fn: () => Promise<void>) => {
  applyPendingUpdate = fn;
};

export const getApplyPendingUpdate = () => applyPendingUpdate;
